import React,{ useContext } from 'react';
import styled from 'styled-components';
import { ServiceRequestContext } from '../../../../index';
import TextColorSelector from './TextColorSelector';

export default function LeftSidePane(){
    /*Context*/
    const { ServiceRequestDetails } = useContext(ServiceRequestContext)
    const { colorCode, companyName, customLogo } = ServiceRequestDetails[0]

    /*Get text color based on background color*/
    const textColor = TextColorSelector(colorCode)

    /*Styles*/
    const LeftPaneDiv = styled.div`
        background-color: ${colorCode};
        width: 421px;
        height: 100%;
        @media (max-width: 599px){
           width: 100%;
        }
    `
    const LogoDiv = styled.div`
        text-align: center;
        @media (max-width: 599px){
            text-align: left;
            padding-left: 12px;
        }
    `
    const LogoImage = styled.img`
        max-height: 120px;
        min-height: 44px;
        max-width: 190px;
        min-width: 44px;
        margin-top: 92px;
        margin-bottom: 15px;
        @media (max-width: 599px){
            margin-top: 5px;
            margin-bottom: 5px;
        }
    `
    const NameDiv = styled.div`
        color: ${textColor};
        font-family: Arial;
        font-size: 38px;
        font-weight: bold;
        text-align: center;
        padding: 15px;
        line-height: 1;
        word-wrap: break-word;
        @media (max-width: 599px){
            display: none;
        }
    `
    return(
        <LeftPaneDiv>
            <LogoDiv id="CustomLogo">
                {customLogo !== null ? <LogoImage src={`data:image/png;base64,${customLogo}`} alt="Company Logo"/> : <></> }
            </LogoDiv>
            <NameDiv id="CompanyName">{companyName}</NameDiv>
        </LeftPaneDiv>
    )
}